@if (lang) {
  <app-search-widget
    [lang]="lang"
    [hidePromocode]="hidePromocode"
    [showLogo]="showLogo"
    [bookingParameters]="bookingParams"
    [maxAllowedChildren]="maxAllowedChildren"
    [maxAllowedPersons]="maxAllowedPersons"
    [refererId]="refererId"
    [alwaysReportSearches]="true"
    [disableSearch]="disableSearch"
    (sentForm)="updateForm($event)">
  </app-search-widget>
}
